import React from 'react'

import { Absolute } from '../helpers/Position'
import { Col } from '../structure/Grid'
import { SmallText } from '../presentation/Text'
import Center from '../helpers/Center'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import Panel from '../structure/Panel'
import Tooltip from '../presentation/Tooltip'

// disabled follows the same visual convention as Button/CheckboxInput (opacity 0.4, click gated
// off); tooltip explains why the action is unavailable instead of hiding it entirely.
export const FloatingMenuItem = ({ onClick, icon, color, label, disabled, tooltip }) => {
  const item = (
    <Col style={{ opacity: disabled ? 0.4 : 1, cursor: disabled ? 'not-allowed' : undefined }}>
      <Link onClick={disabled ? undefined : onClick}>
        <Center direction="column" padding={0.5}>
          <Icon name={icon} size={0.9} color={color || 'dark3'} />
          <SmallText size="xxxsmall" align="center" bold>
            {label}
          </SmallText>
        </Center>
      </Link>
    </Col>
  )

  if (!tooltip) return item

  // topLeft anchors the popup's LEFT edge to the trigger and grows it rightward. This item sits
  // at the left edge of FloatingMenu's own narrow (~3rem) column, which itself floats over open
  // canvas to its right; topRight would anchor the popup's RIGHT edge here instead and grow it
  // leftward, which - now that the popup can be up to 280px wide (see width/maxWidth above) -
  // overflows straight through the narrow menu and into whatever UI sits further left (e.g. the
  // app's sidebar), rather than into the open canvas space to the right.
  return (
    <Tooltip label={tooltip} position="topLeft">
      {item}
    </Tooltip>
  )
}

// zIndex must be high enough (matching other floating overlays, e.g. Select's dropdown) so this
// menu's own stacking context doesn't cap descendants like Tooltip's popup (see Tooltip.js) -
// a nested z-index only wins locally within this context, never against siblings outside it.
const FloatingMenu = ({ children, ...props }) => {
  return (
    <Absolute top={-4.3} left={-4.7} zIndex={1000} {...props}>
      <Center height={10}>
        <Panel noPadding width={3} borderColor="light4">
          <Center direction="column" gutter={0.1}>
            {children}
          </Center>
        </Panel>
      </Center>
    </Absolute>
  )
}

export default FloatingMenu
